import React from 'react'
import Heroseo1 from '../components/seo company/heroseo';
import Seomarketing1 from '../components/seo company/seomarketing';
import Reviews from '../components/Reviews';
import Providingseo1 from '../components/seo company/providingseocards';
import Seoreward from '../components/seo company/seoreward';
import Finally from '../components/seo company/finallyfound';
import Seocard1 from '../components/seo company/seocards';
import Seohistory1 from '../components/seo company/seoresult';
import AgileMethod from '../components/seo company/agilemethod';
import Form1 from '../components/herosection/form';
import FAQseo from '../components/faqseo';
import Landingcontact from '../components/landingcontact';

function Seocompanymain1() {
  return (
    <div>
      <Heroseo1/>
      <Seomarketing1/>
      <Reviews/>
      <Providingseo1/>
      <Seoreward/>
      <Finally/>
      <Seocard1/>
      <Seohistory1/>
      <AgileMethod/>
      <Seocard1/>
      <FAQseo/>
      <Form1/>
      <Landingcontact/>
    </div>
  )
}

export default Seocompanymain1;
